import { render, staticRenderFns } from "./CbsWidgetParam.vue?vue&type=template&id=52b0b397&scoped=true"
import script from "./CbsWidgetParam.vue?vue&type=script&lang=js"
export * from "./CbsWidgetParam.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b0b397",
  null
  
)

export default component.exports